const PrivacyStatement = () => {
  return (
    <>
      <main className="container mx-auto max-w-5xl">
        <div className="text-lg font-semibold text-gray-600 py-8 px-4 sm:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-3xl drop-shadow-xl text-teal-500 font-bold mb-2">
              PRIVACY STATEMENT
            </h2>
            <hr className="border-teal-400 border-[1.5px] dark:border-gray-700 mb-1.5"></hr>

            <hr className="border-teal-400 border-[1.5px] dark:border-gray-700 "></hr>
            <p className="mt-4">
              This page and referenced Privacy Statement tell you our commitment
              to protecting and respecting your privacy.
            </p>
            <p className="mt-8  ">
              This privacy statement explains what information we gather about
              you, what and how we use that information, the lawful basis on
              which that information is used and who we give that information
              to. It also sets out your rights and our obligations in relation
              to your information and who you can contact for more information
              or queries.
            </p>
            <p className="mt-8">
              Please read this Privacy Statement carefully before you start
              using the Site. By using Our Site, you indicate that you accept
              this Privacy Statement and that you agree to abide by them.
            </p>
            <p className="mt-8">Last update on Friday 14 Feb 2024.</p>
            <div className="mt-8">
              <h3 className="text-xl font-bold text-teal-500">
                WHO THIS PRIVACY STATEMENT APPLIES TO AND WHAT IT COVERS
              </h3>
              <p className="mt-2 text-gray-600">
                This privacy statement sets out how we will collect, handle,
                store and protect information about you when providing services
                to you or our clients, or performing any other activities that
                form part of the operation of our business.
              </p>
              <p className="mt-8 ">
                This privacy statement also contains information about when we
                share your personal information with other members of our group
                and other third parties (for example, third parties carrying out
                due diligence activities on our behalf).
              </p>
              <p className="mt-8 ">
                In this privacy statement, your information is sometimes called
                “personal data” or “personal information”. We may also sometimes
                collectively refer to handling, collecting, protecting and
                storing your personal information as “processing” such personal
                information.
              </p>
            </div>
            <div className="mt-8">
              <h3 className="text-xl font-bold text-teal-500">CHILDREN</h3>
              <p className="mt-2 text-gray-600">
                We understand the importance of protecting children's privacy.
                Our website is not designed for, or intentionally targeted at,
                children. It is not our policy to intentionally collect or store
                information about children.
              </p>
            </div>

            <div className="mt-8">
              <h3 className="text-xl font-bold text-teal-500">
                WHAT INFORMATION WE COLLECT
              </h3>
              <p className="mt-2 text-gray-600 ">
                We may collect and process personal data about you because you
                give it to us, because other people give that data to us (for
                example, third party service providers that we use to help
                operate our business) or because it is publicly available.
              </p>
              <p className="mt-6 text-gray-600 ">
                The personal data that we collect or obtain may include: your
                name; age; date of birth; gender; e-mail address; home address;
                country of residence; lifestyle and social circumstances (for
                example, your pastimes); employment and education details (for
                example, the organisation you work for, your job title and your
                education details); your IP address; your browser type and
                language; your access times; complaint details; details of how
                you use our products and services; details of how you like to
                interact with us and other similar information.
              </p>
              <p className="mt-6 text-gray-600 ">
                If you provide information to us by filling in forms on our
                website. This may include information provided at the time of
                registering, subscribing to any of our services, posting
                material, sending messages and posting in our applications,
                giving reviews, making or receiving payments through your User
                Account or requesting further services.
              </p>
              <p className="mt-6 text-gray-600 ">
                Details of transactions and services you deliver via our
                website.
              </p>
              <p className="mt-6 text-gray-600 ">
                We may ask you for information when you report an issue or
                concern or we have or receive a complaint or query about you
                (whether or not a formal dispute is raised).
              </p>
              <p className="mt-6 text-gray-600 ">
                We may keep a record of correspondence between you and us.
              </p>
              <p className="mt-6 text-gray-600 ">
                We may ask you to complete surveys that we use for research
                purposes, although you do not have to respond to them.
              </p>
              <p className="mt-6 text-gray-600 ">
                Details of the messages you send and receive using our
                applications including without limitation when you sent or
                received a message and the contents of that message. Messages
                are not private and are not confidential.
              </p>
              <p className="mt-6 text-gray-600 ">
                We may collect and process personal data about you from other
                sources as follows:
              </p>
              <ul className="mt-4 text-gray-600 font-semibold list-disc list-inside mb-6">
                <div className="flex mx-2">
                  <li className=" "></li>
                  <p>
                    We may collect or obtain personal data from you because we
                    observe or infer that data about you from the projects you
                    undertake, or the way you interact with us or others. For
                    example, to improve your experience when you use our website
                    and ensure that it is functioning effectively, we (or our
                    service providers) may use cookies (small text files stored
                    in a user’s browser) and Web beacons which may collect
                    personal data. Additional information on how we use cookies
                    and other tracking technologies and how you can control
                    these can be found in our Cookie Policy.
                  </p>
                </div>

                <div className="flex mx-2 mt-3">
                  <li className=" "></li>
                  <p className="">
                    We sometimes supplement the information that you provide
                    with information received from third parties. For instance,
                    credit reference agencies, search information providers, or
                    other companies (subject to their privacy policies and
                    applicable law), and from other accounts we have reason to
                    believe you control (whether in part or in whole).
                  </p>
                </div>
                <div className="flex mx-2 mt-3">
                  <li className=" "></li>
                  <p>
                    Where we are provided with personal data about you by any
                    third party such as a service provider, we take steps to
                    ensure that that third party has complied with the privacy
                    laws and regulations relevant to that information; this may
                    include, for example, that the third party has provided you
                    with notice of the collection (and other matters) and has
                    obtained any necessary consent (if applicable) for us to
                    process that information as described in this privacy
                    statement. We may use your personal data to gather feedback
                    regarding your experience you may have with our platform.
                    This helps our business grow by assembling useful
                    information from our end-user.
                  </p>
                </div>
              </ul>
            </div>

            <div className="mt-8">
              <h3 className="text-xl font-bold text-teal-500">
                USE OF PERSONAL DATA
              </h3>
              <p className="mt-2 text-gray-600">
                We will use your personal data to fulfil your requests and we
                will ask only for data that is adequate, relevant and not
                excessive for those purposes. Where we send you information for
                any purpose, it may be sent by e-mail or post. When we ask you
                for personal data it may include the following purposes:
              </p>
              <ul className="mt-4 text-gray-600 font-semibold list-disc list-inside mb-6">
                <div className="flex mx-2">
                  <li className=" "></li>
                  <p>
                    We may contact you occasionally to inform you of new
                    products and services we will be providing;
                  </p>
                </div>

                <div className="flex mx-2 mt-3">
                  <li className=" "></li>
                  <p className="">
                    We may send you regular updates on issues we think will be
                    of interest to you;
                  </p>
                </div>
                <div className="flex mx-2 mt-3">
                  <li className=" "></li>
                  <p>
                    We may send you requested information on our products and
                    services;
                  </p>
                </div>
                <div className="flex mx-2 mt-3">
                  <li className=" "></li>
                  <p>
                    We may use your personal data for marketing purposes and
                    market research;
                  </p>
                </div>
                <div className="flex mx-2 mt-3">
                  <li className=" "></li>
                  <p>
                    We may use your personal data internally to provide you with
                    the services offered by us via this website, to administer
                    this website and to help us improve our services;
                  </p>
                </div>
                <div className="flex mx-2 mt-3">
                  <li className=" "></li>
                  <p>
                    We may use your personal data for managing and making
                    information available to third-party service providers (e.g.
                    providers of due diligence services or in order to support
                    our information technology) and our affiliates;
                  </p>
                </div>
                <div className="flex mx-2 mt-3">
                  <li className=" "></li>
                  <p>
                    We may use your personal data to allow you to participate in
                    interactive features of our service when you choose to do
                    so;
                  </p>
                </div>
                <div className="flex mx-2 mt-3">
                  <li className=" "></li>
                  <p>
                    We may use your personal data to notify you about changes to
                    our services, terms and conditions, policies or website;
                  </p>
                </div>
                <div className="flex mx-2 mt-3">
                  <li className=" "></li>
                  <p>
                    We may use your personal data to manage risk, or to
                    investigate, detect, prevent, and/or remediate fraud,
                    suspected fraud or other potentially illegal or prohibited
                    activities;
                  </p>
                </div>
                <div className="flex mx-2 mt-3">
                  <li className=" "></li>
                  <p>
                    We may use your personal data pursuant to applicable legal
                    or regulatory requirements or to respond to requests and
                    communications from competent authorities (including courts
                    and tribunals);
                  </p>
                </div>
                <div className="flex mx-2 mt-3">
                  <li className=" "></li>
                  <p>
                    We may use your personal data for the services we receive
                    from our professional advisors, such as lawyers, accountants
                    and consultants;
                  </p>
                </div>
                <div className="flex mx-2 mt-3">
                  <li className=" "></li>
                  <p>
                    We may use your personal data for protecting our rights,
                    those of our clients, or protecting those of our affiliates.
                  </p>
                </div>
                <div className="flex mx-2 mt-3">
                  <p>
                    None of the information that we request from you is
                    mandatory. However, where such information is not provided
                    to us, we may be unable to identify, protect, or return your
                    money or assets.
                  </p>
                </div>
              </ul>
            </div>

            <div className="mt-8">
              <h3 className="text-xl font-bold text-teal-500">
                LEGAL GROUNDS WE USE FOR PROCESSING PERSONAL INFORMATION
              </h3>
              <p className="mt-2 text-gray-600">
                We are not allowed to process personal information if we do not
                have a valid legal ground. Therefore, we will only process your
                personal information for the purposes outlined above because:
              </p>
              <ul className="mt-4 text-gray-600 font-semibold list-disc list-inside mb-6">
                <div className="flex mx-2">
                  <li className=" "></li>
                  <p>
                    of our legitimate interests in the performance of activities
                    that form part of the operation of our business;
                  </p>
                </div>

                <div className="flex mx-2 mt-3">
                  <li className=" "></li>
                  <p className="">
                    of our legitimate interests in the effective and lawful
                    operation of our business so long as such interests are not
                    outweighed by your interests or fundamental rights and
                    freedoms;
                  </p>
                </div>
                <div className="flex mx-2 mt-3">
                  <li className=" "></li>
                  <p>
                    of the legal and regulatory obligations that we are subject
                    to, such as keeping records for tax purposes or providing
                    information to a public body or law enforcement agency; or
                  </p>
                </div>
                <div className="flex mx-2 mt-3 mb-8">
                  <li className=" "></li>
                  <p>
                    the information is required in order to carry out the
                    activities that form part of the operation of our business
                    (e.g. the processing is necessary to perform our contractual
                    obligations towards you).
                  </p>
                </div>
                <p>
                  Examples of the ‘legitimate interests referred to above are:
                </p>
                <div className="flex mx-2 mt-3">
                  <li className=" "></li>
                  <p>
                    to benefit from cost-effective services (e.g. we may opt to
                    use certain IT platforms offered by suppliers);
                  </p>
                </div>
                <div className="flex mx-2 mt-3">
                  <li className=" "></li>
                  <p>
                    to verify the accuracy of the information provided by a
                    third party;
                  </p>
                </div>
                <div className="flex mx-2 mt-3">
                  <li className=" "></li>
                  <p>to prevent fraud or criminal activity;</p>
                </div>
                <div className="flex mx-2 mt-3">
                  <li className=" "></li>
                  <p>
                    to safeguard the security of our IT systems, architecture
                    and networks, and of our physical premises; and
                  </p>
                </div>
                <div className="flex mx-2 mt-3">
                  <li className=" "></li>
                  <p>
                    to exercise our rights under Articles 16 and 17 of the
                    Charter of Fundamental Rights, including our freedom to
                    conduct business and right to property.
                  </p>
                </div>
                <p className="mt-6 text-gray-600">
                  To the extent that we process any sensitive personal data
                  relating to you for any of the purposes outlined above, we
                  will do so because either: (i) we are required by law to
                  process that data in order to ensure we meet our ‘know your
                  client’ and ‘anti-money laundering’ obligations (or other
                  legal obligations imposed on us); (ii) the processing is
                  necessary to carry out our obligations under employment,
                  social security or social protection law; (iii) the processing
                  is necessary for the establishment, exercise or defence of
                  legal claims; or (iv) you have made the data manifestly
                  public.
                </p>
              </ul>
              <h3 className="mt-8 text-xl font-bold text-teal-500">
                UNSUBSCRIBE
              </h3>
              <p className="mt-2 text-gray-600">
                We may, from time to time, e-mail or post you information to
                make you aware of our other similar products and services which
                may be of interest to you. If you do not wish to receive emails
                or post from us for these purposes, or if you want to be removed
                from our electronic mailing list you can either select
                “unsubscribe” from any of the marketing emails that we send or
                alternatively contact us.
              </p>

              <h3 className="mt-8 text-xl font-bold text-teal-500">
                ANONYMOUS DATA COLLECTED THROUGH THIS WEBSITE
              </h3>
              <p className="mt-2 text-gray-600">
                In addition to the information we collect as described above, we
                use technology to collect anonymous information about the use of
                our website. For example, our web server automatically logs
                which pages of our website our visitors view, their IP addresses
                and which web browsers our visitors use. This technology does
                not identify you personally, it simply enables us to compile
                statistics about our visitors and their use of our website.
              </p>
              <p className="mt-2 text-gray-600">
                Our website contains hyperlinks to other pages on our website.
                We may use technology to track how often these links are used
                and which pages on our website our visitors choose to view.
                Again this technology does not identify you personally - it
                simply enables us to compile statistics about the use of these
                hyperlinks.
              </p>
            </div>
            <div className="mt-8">
              <h3 className="text-xl font-bold text-teal-500">
                LINK TO OTHER WEBSITES
              </h3>
              <p className="mt-2 text-gray-600">
                This website may contain hyperlinks to websites that are not
                operated by us. These hyperlinks are provided for your reference
                and convenience only and do not imply any endorsement of the
                activities of these third-party websites or any association with
                their operators. We do not control these websites and are not
                responsible for their data or privacy practices. We urge you to
                review any privacy policy posted on any site you visit before
                using the site or providing any personal data about yourself.
              </p>

              <h3 className="mt-8 text-xl font-bold text-teal-500">COOKIES</h3>
              <p className="mt-2 text-gray-600">
                In order to collect the anonymous data described in the
                preceding paragraph, we may use temporary "cookies" and similar
                technologies (e.g. web beacons, pixels, ad tags and device
                identifiers) to recognise you and/or your device(s) that remain
                in the cookies file of your browser for a specific amount of
                time. For example, we use Google Analytics to help us take and
                analyse visitor information such as browser usage and new
                visitor numbers. We use the information to compile reports and
                to help us improve the website. The cookies collect information
                in an anonymous form, including the number of visitors to the
                website and blog, where visitors have come to the website from
                and the pages they visited. Please note that the names of
                cookies, pixels and other technologies may change over time.
              </p>
              <p className="mt-4 text-gray-600">
                Cookies by themselves cannot be used to discover the identity of
                the user. A cookie is a small piece of information which is sent
                to your browser and stored on your computer's hard drive.
                Cookies do not damage your computer. You can set your browser to
                notify you when you receive a cookie. This enables you to decide
                if you want to accept it or not. We also use your IP address to
                help diagnose problems with our server and to administer our
                website. An IP address is a numeric code that identifies your
                computer on a network, or in this case, the internet. Your IP
                address is also used to gather broad demographic information.
                Cookies are useful because they allow a website to recognise a
                user’s device, preferences and generally help to improve your
                online experience.
              </p>
              <p className="mt-2 text-gray-600">
                Please also refer to our Cookie Policy{" "}
                <a
                  href="https://www.peopleperhour.com/cookies "
                  className="text-teal-500 underline"
                >
                  Cookie Policy.
                </a>
              </p>

              <h3 className="mt-8 text-xl font-bold text-teal-500">
                SOCIAL MEDIA
              </h3>
              <p className="mt-2 text-gray-600">
                Our website may also contain plugins and other features that
                integrate third-party social media platforms into our website so
                that we can improve our offer and make it more interesting for
                you as a user. You will be able to activate them manually. If
                you do so, the third-party companies who operate these platforms
                may be able to identify you, they may be able to determine how
                you use this website and they may link and store this
                information with your social media profile. Please consult the
                data protection policies of these social media platforms to
                understand what they will be doing with your personal data. If
                you activate these plugins and other features, you will be doing
                so at your own risk as we do not have any influence on the data
                collected and data processing operation, nor are we aware of the
                full extent of data collection, the purposes and the storage
                periods.
              </p>
              <h3 className="mt-8 text-xl font-bold text-teal-500">
                DISCLOSURE OF YOUR PERSONAL DATA
              </h3>
              <p className="mt-2 text-gray-600">
                In connection with one or more of the purposes outlined in the
                “Use of personal data” section above, we may disclose details
                about you to: our affiliates; third parties that provide
                services to us and/or our affiliates, such as our lawyers;
                competent authorities (including courts and supervisory or other
                authorities); your advisers or where applicable, your employer;
                credit reference agencies or other organisations that help us
                make decisions and reduce the incidence of fraud; and other
                third parties that reasonably require access to personal data
                relating to you for one or more of the purposes outlined in the
                “Use of personal data” section above.
              </p>
              <p className="mt-4 text-gray-600">
                Where you have chosen to connect your account on our Website to
                your Facebook or LinkedIn account we may share, disclose, and
                transfer personal data to Facebook or LinkedIn, as applicable.
                This permission will be requested when you connect your
                accounts. If you have given this permission you may then disable
                this function at any time by changing your Facebook, LinkedIn or
                our account settings (as applicable).
              </p>
              <p className="mt-4 text-gray-600">
                Where appropriate, before disclosing personal data to a third
                party, we contractually require the third party to take adequate
                precautions to protect that data and to comply with applicable
                law.
              </p>
              <p className="mt-4 text-gray-600">
                Where you have consented, we may also share your personal data
                with other companies within our group of companies who may
                contact you about their products or services that may interest
                you.
              </p>
              <p className="mt-4 text-gray-600">
                Please note that some of the recipients of your personal data
                referenced above may be based in countries outside of the
                European Union whose laws may not provide the same level of data
                protection. Those countries currently include India and the
                United States of America. In such cases, we will ensure that
                there are adequate safeguards in place to protect your personal
                data that comply with our legal obligations. To ensure this
                level of protection for your personal information, we typically
                use a data transfer agreement with the recipient based on
                standard contractual clauses approved by the European
                Commission. A copy of these clauses is available by requesting
                us.
              </p>
              <h3 className="mt-8 text-xl font-bold text-teal-500">
                PROTECTION OF PERSONAL DATA
              </h3>
              <p className="mt-2 text-gray-600">
                All personnel accessing personal information must comply with
                the internal rules and processes in relation to the processing
                of personal data to protect them and ensure the confidentiality
                of such information.
              </p>
              <p className="mt-2 text-gray-600">
                We have also implemented adequate technical and organisational
                measures to protect personal data against unauthorised,
                accidental or unlawful destruction, loss, alteration, misuse,
                disclosure or access and against all other unlawful forms of
                processing. These security measures have been implemented taking
                into account the state of the art of the technology, their cost
                of implementation, the risks presented by the processing and the
                nature of the personal information, with particular care for
                sensitive information.
              </p>
              <p className="mt-2 text-gray-600">
                Although we use appropriate security measures once we have
                received your personal data, the transmission of data over the
                internet (including by e-mail) is never completely secure. We
                endeavour to protect personal data, but we cannot guarantee the
                security of data transmitted to us or by us.
              </p>

              <h3 className="mt-8 text-xl font-bold text-teal-500">
                HOW LONG WE KEEP YOUR INFORMATION FOR
              </h3>
              <p className="mt-2 text-gray-600">
                We will hold your personal data on our systems for the longest
                of the following periods: (i) as long as is necessary for the
                relevant activity (which is typically 7 years); (ii) any
                retention period that is required by law or regulation; or (iii)
                the end of the period in which litigation or investigations
                might arise in respect of our activities.
              </p>
            </div>
            <div className="mt-8">
              <h3 className="text-xl font-bold text-teal-500">YOUR RIGHTS</h3>
              <p className="mt-2 text-gray-600">
                You have various rights in relation to your personal data. In
                particular, you have a right to:
              </p>
              <ul className="mt-4 text-gray-600 font-semibold list-disc list-inside mb-6">
                <div className="flex mx-2">
                  <li className=" "></li>
                  <p>request a copy of personal data we hold about you;</p>
                </div>

                <div className="flex mx-2 mt-3">
                  <li className=" "></li>
                  <p className="">
                    ask that we update the personal data we hold about you, or
                    correct such personal data that you think is incorrect or
                    incomplete;
                  </p>
                </div>
                <div className="flex mx-2 mt-3">
                  <li className=" "></li>
                  <p>
                    ask that we delete personal data that we hold about you, or
                    restrict the way in which we use such personal data;
                  </p>
                </div>
                <div className="flex mx-2 mt-3">
                  <li className=" "></li>
                  <p>object to our processing of your personal data;</p>
                </div>
                <div className="flex mx-2 mt-3">
                  <li className=" "></li>
                  <p>
                    ask that we restrict our processing of your personal data;
                    and
                  </p>
                </div>
                <div className="flex mx-2 mt-3">
                  <li className=" "></li>
                  <p>
                    ask for the portability of personal data - receive the
                    Personal Data you have provided to us in a structured,
                    commonly used and machine-readable form and transmit it to
                    another data controller.
                  </p>
                </div>

                <p className="mt-6 text-gray-600">
                  To exercise any of your rights, or if you have any other
                  questions about our use of your personal data, please contact
                  us.
                </p>
              </ul>
            </div>
            <h3 className="mt-8 text-xl font-bold text-teal-500">
              RIGHT TO COMPLAIN
            </h3>
            <p className="mt-2 text-gray-600">
              If you are unhappy with the way we handled your personal
              information or any privacy query or request you have raised with
              us you also have a right to complain to a data protection
              authority in the place where you live or work, or in the place
              where you think an issue in relation to your data has arisen. A
              list of national data protection authorities can be found 
              <a
                href="https://commission.europa.eu/law/law-topic/data-protection_en "
                className="text-teal-500 underline"
              >
                here.
              </a>
            </p>
            <h3 className="mt-8 text-xl font-bold text-teal-500">
              CHANGES TO OUR PRIVACY STATEMENT
            </h3>
            <p className="mt-2 text-gray-600">
              We may modify or amend this Privacy Statement from time to time.
            </p>
            <p className="mt-2 text-gray-600">
              To let you know when we make changes to this privacy statement, we
              will amend the revision date at the end of this page. The new
              modified or amended privacy statement will apply from that
              revision date. Therefore, we encourage you to periodically review
              this statement to be informed about how we are protecting your
              information.
            </p>
            <h3 className="mt-8 text-xl font-bold text-teal-500">CONTACT</h3>
            <p className="mt-2 text-gray-600">
              If you have any questions, comments or requests regarding this
              Privacy Statement, please contact us.
            </p>
          </div>
        </div>
      </main>
    </>
  );
};

export default PrivacyStatement;
